export const PDFLinks = {
    
    // Polizze
    MODULO_DENUNCIA_SINISTRI: '/polizze/GBSAPRI-MODULO-DENUNCIA-SINISTRI-CONAF.pdf',
    PRIVACY_SINISTRI: '/polizze/GBSAPRI-SPA-PRIVACY-SINISTRI.pdf',
    NORMATIVA_POLIZZE_RIFERIMENTO: '/polizze/DPR_137_7_AGOSTO_2012.pdf',
    LINEE_GUIDA_POLIZZE: '/polizze/LINEE-GUIDA-ADESIONE-POLIZZA-PROFESSIONALE-COLLETTIVA-2025-2026.pdf',
    VADEMECUM_POLIZZE: '/polizze/VADEMECUM-ASSICURATI-CONAF.pdf',
    REGOLAMENTO_POLIZZA_COLLETTIVA: '/polizze/3_Regolamento%20Polizza%20collettiva%20CONAF_agg.%202021_9.2.3.1.pdf',

    // Anagrafica
    DICHIARAZIONE_SOSTITUTIVA_PAGAMENTO_BOLLO: '/iot/DichiarazioneSostitutivaDiPagamentoBollo.pdf'
  };